module.exports = __webpack_public_path__ + "img/5.c5eff6a6.jpg";